// src/CalculatorModeSlider.js
import React from 'react';
import './calculatorModeSlider.css';

const STOPS = [
  { id: 'off', icon: '🚫', label: 'Aus' },
  { id: 'basic', icon: '🧮', label: 'Basic' },
  { id: 'full', icon: '📐', label: 'Vollwertig' },
];

export default function CalculatorModeSlider({ mode, onChange }) {
  return (
    <div className="calcModeSlider">
      {STOPS.map((s) => (
        <button
          key={s.id}
          className={`calcModeStop ${mode === s.id ? 'active' : ''}`}
          onClick={() => onChange(s.id)}
          title={s.label}
        >
          <span className="calcModeIcon">{s.icon}</span>
          <span className="calcModeLabel">{s.label}</span>
        </button>
      ))}
    </div>
  );
}
